export const CREED_CONTENT = {
  title: 'Our Creed',
  subtitle: 'At Nirva, we believe:',
  buttonText: 'Explore Our Services',
};

export const CREED_BELIEFS = [
  'When the mind heals, life transforms.',
  'Professional, ethical, relational care is the highest standard.',
  'Healing begins within—through presence and compassion.',
  'Hypnotherapy is both a science and an art of transformation.',
  'The mind is naturally clear and beautiful when fear dissolves.',
  'A peaceful mind radiates outward—healing relationships, communities, and the world.'
];
